// extracted by mini-css-extract-plugin
export default {"maintenanceTaskCost":"maintenanceTaskCost-f2da"};